module.exports = __webpack_public_path__ + "static/empty-states-levels-do-b6789d1081b9c325415e5ab92cd91fce.png";